<template>
  <div v-if="isWidget" class="grid grid-cols-2 gap-3 mb-3">
    <tamara :price="productPrice">
      <template #description>
        <installment-info :price="installmentProductPrice"/>
      </template>
    </tamara>
    <tabby :price="productPrice">
      <template #description>
        <installment-info :price="installmentProductPrice"/>
      </template>
    </tabby>
  </div>
</template>

<script setup>
import Tabby from "@/components/product/installment-widgets/Tabby"
import Tamara from "@/components/product/installment-widgets/Tamara"
import InstallmentInfo from "@/components/product/installment-widgets/InstallmentInfo";

const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})

const isWidget = computed(() => props.data?.show_tamara?.show)

const productPrice = computed(() => parseFloat(props.data?.show_tamara?.price) || 0)
const installmentProductPrice = computed(() => Math.round(productPrice.value / 4))
</script>

<style scoped>

</style>